export default function SearchController(module) {
    /**
     * @ngdoc controller
     * @name FeedGridController
     * @description
     * Collects information used to filter the feed and sets up configuration for modal carousel.
     * */
    angular.module(module || 'app')
        .controller('SearchController', SearchController);

    SearchController.$inject = ['$scope', '$attrs', '$window', '$timeout', '$q', 'feedResource', 'productResource'];
    function SearchController($scope, $attrs, $window, $timeout, $q, feedResource, productResource) {
        var vm = this;
        vm.$onInit = function () {
            vm.params = JSON.parse($attrs.parameters);
            vm.labelOverides = JSON.parse($attrs.labelOverrides);
            var hasHistory = $window.history.state;
            if ($window.history) {
                $window.addEventListener('beforeunload', event => {
                    var state = angular.copy(vm.params);
                    if (state.categories) {
                        state.categoriesRaw = state.categories.map(item => item.tags);
                    }
                    state.page = vm.page;
                    $window.history.replaceState(state, document.querySelector('title').innerText);
                });
                if (hasHistory) {
                    vm.params = angular.copy($window.history.state);
                }
            }
            vm.pageTypes = angular.copy(vm.params.pageTypes || []);
            vm.page = vm.params.page;
            vm.searchTerm = vm.params.searchTerm;
            vm.sortType = vm.params.sortType;
            vm._filtersData = JSON.parse($attrs.filters);
            vm.filters = [];
            vm.initCategories = JSON.parse($attrs.categories);
            vm._calibrateFilters();
            vm.includeDiscontinued = vm.params.includeDiscontinued === '1';
            vm.products = [];
            vm.product = vm.params.product;
            if ($attrs.customerId) {
                var deferred = $q.defer();
                vm.cludoReady = deferred.promise;
                $window.loadScript('https://customer.cludo.com/scripts/bundles/analytics/1.0.3/cludo-statistics.app.js', () => {
                    CludoSearch.initialize($attrs.customerId, $attrs.engineId, true);
                    deferred.resolve();
                });
            }
            vm._videoPopup = $('#video-popup');
            vm._videoPopup.on('closed.zf.reveal', () => {
                vm.setIframeUrl('');
            });

            if ($attrs.withProducts === '1') {
                vm._getProducts(true);
            }
        }

        //Video modal start
        vm.openVideoModal = (element, src, item) => {
            if (element.currentTarget.className == "open-video") {
                element.preventDefault();
                if (!src.includes('embed') && src.includes('youtu')) {
                    var videoId = vm.getVideoEmbedUrl(src);
                    var videoUrl = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1';
                    vm.setIframeUrl(videoUrl);
                }
                else {
                    vm.setIframeUrl(src);
                }

                vm._videoPopup.foundation('open');
            } else {
                console.log('item', item);
                var href = element.currentTarget.href;
                var hostUrl = $window.location.origin;
                var modal = $("#leave-message");
                if (!href.includes(hostUrl)) {
                    element.preventDefault();
                    element.stopImmediatePropagation();

                    modal.find("a[target='_blank']").attr("href", href);
                    var spanTag = "<span class='external-url'>" + href + "</span>";
                    if (modal.html().includes("{url}")) {
                        modal.html(modal.html().replace(/{url}/g, spanTag));
                    }
                    else {
                        modal.find(".external-url").text(href);
                    }
                    modal.foundation('open');
                } else if (item.type.toLowerCase() === 'documents' || href.contains('.htm') || href.contains('.html')) {
                    element.preventDefault();
                    element.stopImmediatePropagation();
                    window.open(href, '_blank');
                }
            }
        }

        vm.setIframeUrl = (src) => {
            document.getElementById('video-iframe').innerHTML = '<iframe id="video-popup-frame" src="' + src + '" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe>';
        }

        vm.getVideoEmbedUrl = (url) => {
            const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
            const match = url?.match(regExp);
            return (match && match[2].length === 11)
                ? match[2]
                : null;
        }
        //Video modal end

        vm._getProducts = (initLoad) => {
            let brand = '';
            let isDiscontinued = false;
            if (vm.params.categories && vm.params.categories.length && vm.params.categories[0].tags && vm.params.categories[0].tags.length) {
                brand = vm.params.categories[0].tags[0];
            }

            if (!initLoad) {
                vm.product = null;
                vm.params.product = null;
            }
            productResource.list({
                brand: brand,
                isDiscontinued: vm.params.includeDiscontinued === true || vm.params.includeDiscontinued == '1',
                searchTerm: vm.params.searchTerm
            }).then((res) => {
                vm.products = res.data ?? [];
            });
        }

        vm.searchByText = () => {
            vm.params = angular.copy(vm.params);
            vm.page = 1;
            vm.params.page = 1;
            vm.params.searchTerm = vm.searchTerm;
            vm._getProducts();
            vm._calibrateFilters();
        }

        vm.updateProduct = () => {
            vm.params = angular.copy(vm.params);
            //vm.params.categories = null;
            vm.params.product = vm.product;
            /*for (var i = 0; i < vm.categories.length; i++) {
                vm.categories[i] = null;
            }
            vm.params.categories = null;*/
            vm.page = 1;
            vm.params.page = 1;
        }

        vm.updateDiscontinued = () => {
            vm.params = angular.copy(vm.params);
            vm.params.includeDiscontinued = vm.includeDiscontinued ? "1" : "0";
            vm.page = 1;
            vm.params.page = 1;
            vm._getProducts();
        }

        vm.updateCategories = (index) => {
            if (vm._categoriesCalibrated) {
                var categories = [];
                vm.categories.forEach((category, i) => {
                    categories.push({
                        tags: typeof (category) === 'string' ? [category] : angular.copy(category),
                        orLogic: vm.filters[i].orLogic
                    });
                });
                vm.params = angular.copy(vm.params);
                /*vm.product = null;
                vm.params.product = null;*/
                vm.params.categories = categories.length ? categories : null;
                vm.page = 1;
                vm._getProducts();
            }
        }

        vm.syncPage = (page, items) => {
            vm.page = page;
            if (vm.cludoReady) {
                vm.cludoReady.then(() => {
                    var queryLog = CludoSearch.trackQuery(
                        vm.searchTerm,
                        vm.searchTerm + '-' + new Date().getTime(),
                        items.length,
                        page,
                        $attrs.referer
                    );
                    CludoSearch.trackClicks(queryLog, '.widget-search .search-result');
                });
            }
        }

        vm.updatePageTypes = () => {
            vm.params = angular.copy(vm.params);
            vm.page = 1;
            vm.params.page = 1;
            vm.params.pageTypes = angular.copy(vm.pageTypes);
        }

        vm.updateSort = () => {
            vm.params = angular.copy(vm.params);
            vm.params.sortType = vm.sortType;
            vm.page = 1;
            vm.params.page = 1;
        };

        vm.openFilters = () => {
            vm.filtersOpen = true;
        };

        vm.closeFilters = () => {
            vm.filtersOpen = false;
        }

        vm._calibrateFilters = () => {
            vm.categories = [];
            var sourceIds = $attrs.sourceId ? [$attrs.sourceId] : [];
            var calibrationPromises = [];
            vm._filtersData.forEach(filters => {
                calibrationPromises.push(feedResource.calibrateFilters(sourceIds, 0, filters.tags, null, null, vm.params.culture, vm.params.searchTerm));
            });
            calibrationPromises.forEach((promise, i) => {
                promise.then(function (result) {
                    var filters = result.data;
                    var matches = [];
                    filters.forEach(filter => {
                        filter.value = filter.key.replaceAll('-', '');
                        filter.label = filter.name;
                        if (vm.initCategories.length) {
                            if (vm.initCategories.indexOf(filter.value) > -1) {
                                matches.push(filter.value);
                            }
                        }
                    });
                    vm.filters[this] = {
                        tags: filters,
                        orLogic: vm._filtersData[this].orLogic
                    };
                    vm.categories[this] = matches[0];
                }.bind(i));
            });

            $q.all(calibrationPromises)
                .then(() => {
                    vm._categoriesCalibrated = true;
                });
        }
    }
};